module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ca.")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("circa")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("cf.")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("compare")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ch(s).")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("chapter(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CC")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Continental Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ConcC")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Concordia Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Calvin Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("d.")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("died")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Eng.")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("English")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ESV")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("English Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Heb.")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hebrew")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")]), _vm._v(" Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masoretic Text")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("n(n).")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("note(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAC")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NASB")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Standard Bible (1995)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Version (2011)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIVAC")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV Application Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NJB")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NJPS")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Jewish Publication Society of America Tanakh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OT")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("p(p).")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("page(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TOTC")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tyndale Old Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("v(v)")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("verse(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01e7813d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Abbreviations.vue
// module id = 81
// module chunks = 0